import React, { ReactNode } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

interface IWhiteLabelLinkProps {
  to: string;
  isActive: boolean;
  children: ReactNode;
  disabled?: boolean;
  id?: string;
}
const WhiteLabelLink = ({
  to,
  children,
  isActive,
  disabled,
  id,
}: IWhiteLabelLinkProps) => {
  if (disabled) {
    return <div className="nav-link opacity-25">{children}</div>;
  }

  return (
    <Link
      id={id}
      to={to}
      className={classNames("nav-link", {
        "bg-success text-white rounded": isActive,
      })}
    >
      {children}
    </Link>
  );
};

export default WhiteLabelLink;
